import React from "react";
import PropTypes from "prop-types";
import { View } from "react-native";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import ENV from "app/utils/ENV";

import textHelpers from "app/utils/textHelpers";
import iconHelpers from "app/utils/iconHelpers";
import colorHelpers from "app/utils/colorHelpers";

import { StyleContext } from "app/contexts/Style";

// import "root/assets/fonts/fontello.css";

export default class Icon extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    name: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    hideOverflow: PropTypes.bool,
    onPress: PropTypes.func,
    // style
  };

  static defaultProps = {
    color: colors.foreground,
    size: sizes.itemHeight,
  };

  render() {
    let { name, color, style, size, hideOverflow, onPress, iconScale } =
      this.props;
    let { iconClass, iconName, scale, rotation } =
      iconHelpers.findIconClass(name);
    let IconClass = iconClass;
    if (name == "select") color = colors.placeholder;

    // style = textHelpers.styleToObject(style)

    let res = {};
    if (style && Array.isArray(style)) {
      for (let sty of style) {
        res = { ...res, ...sty };
      }
    } else {
      res = style;
    }
    style = res;

    let iconSize = size;
    if (!!scale) {
      iconSize *= scale;
    }
    if (!!iconScale) {
      iconSize *= iconScale;
    }

    if (this.props.doubleShot) {
      return (
        <View style={{ justifyContent: "center", alignItems: "center" }}>
          <View style={{ position: "absolute" }}>
            <IconClass
              onPress={onPress}
              name={iconName}
              color={this.context.colors.lightForeground}
              style={[
                {
                  textAlign: "center",
                  lineHeight: size,
                  fontSize: iconSize,
                  height: size,
                  width: size,
                },
                hideOverflow
                  ? { borderRadius: size / 2, overflow: "hidden" }
                  : null,
                style,
                //{borderWidth: 2,},
                ENV.WEB && { userSelect: "none" },
                !!rotation && {
                  transform: [!!rotation && { rotate: `${rotation}deg` }],
                },
              ]}
              // pointerEvents={'none'}
              // selectable={false}
            />
          </View>
          <View style={{ position: "absolute" }}>
            <IconClass
              onPress={onPress}
              name={iconName}
              color={colorHelpers.hexToRgbaString(color, 0.5)}
              style={[
                {
                  textAlign: "center",
                  lineHeight: size,
                  fontSize: iconSize,
                  height: size,
                  width: size,
                },
                hideOverflow
                  ? { borderRadius: size / 2, overflow: "hidden" }
                  : null,
                style,
                //{borderWidth: 2,},
                ENV.WEB && { userSelect: "none" },
                !!rotation && {
                  transform: [!!rotation && { rotate: `${rotation}deg` }],
                },
              ]}
              // pointerEvents={'none'}
              // selectable={false}
            />
          </View>
        </View>
      );
    }

    return (
      <IconClass
        onPress={onPress}
        name={iconName}
        color={color}
        style={[
          {
            textAlign: "center",
            lineHeight: size,
            fontSize: iconSize,
            height: size,
            width: size,
          },
          hideOverflow ? { borderRadius: size / 2, overflow: "hidden" } : null,
          style,
          //{borderWidth: 2,},
          ENV.WEB && { userSelect: "none" },
          !!rotation && {
            transform: [!!rotation && { rotate: `${rotation}deg` }],
          },
        ]}
        // pointerEvents={'none'}
        // selectable={false}
      />
    );
  }
}
